import { f as r } from "../internals/function-call.js";
import { f as n } from "../internals/fix-regexp-well-known-symbol-logic.js";
import { a as e } from "../internals/an-object.js";
import { i as t } from "../internals/is-null-or-undefined.js";
import { r as s } from "../internals/require-object-coercible.js";
import { s as a } from "../internals/same-value.js";
import { t as i } from "../internals/to-string.js";
import { g as o } from "../internals/get-method.js";
import { r as l } from "../internals/regexp-exec-abstract.js";
n("search", function (n, m, f) {
  return [function (e) {
    var a = s(this),
      l = t(e) ? void 0 : o(e, n);
    return l ? r(l, e, a) : new RegExp(e)[n](i(a));
  }, function (r) {
    var n = e(this),
      t = i(r),
      s = f(m, n, t);
    if (s.done) return s.value;
    var o = n.lastIndex;
    a(o, 0) || (n.lastIndex = 0);
    var u = l(n, t);
    return a(n.lastIndex, o) || (n.lastIndex = o), null === u ? -1 : u.index;
  }];
});